// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"9d07ec46","596":"48ef68ff"}[chunkId] + ".chunk.css";
};